module.exports = __webpack_public_path__ + "static/media/logo_ecg_attr.065e87a0.svg";